<template>
  <section class="map" id="location">
    <h2 class="name">Wedding Location / ទីតាំងផ្ទះការ</h2>
    <iframe
      width="100%"
      height="400"
      frameborder="0"
      style="border:0"
      allowfullscreen
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
      :src="mapUrl"
    ></iframe>
  </section>
</template>

<script>
export default {
  data() {
    return {
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3902.2860860726314!2d105.413686!3d12.023814999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDAxJzI1LjciTiAxMDXCsDI0JzQ5LjMiRQ!5e0!3m2!1sen!2skh!4v1773560090819!5m2!1sen!2skh"
    };
  }
};
</script>

<style scoped>
.map {
  padding: 20px;
  text-align: center;
}
.name {
  font-family: 'Moulpali', sans-serif;
}
</style>
